import React from 'react'

import LicensePlate from '../../form/LicensePlate'

export interface IRegistrationCellProps {
  content: string
  size?: React.ComponentProps<typeof LicensePlate>['size']
}

export const RegistrationCell = ({ content, size }: IRegistrationCellProps) =>
  content ? <LicensePlate registration={content} size={size} /> : null

export default React.memo(RegistrationCell)
